import allianzKontaktLogo from '@/images/clients/allianzkontakt-logo.jpg'
import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

export const AllianzKontakt: IPartnerSettings = {
  partner: 'AllianzKontakt',
  hosts: [
    'cebia.allianzkontakt.cz',
    //, 'localhost:44470'
  ],
  logo: allianzKontaktLogo,
  market: Market.CZ
}
